import React, { useState, useRef, useEffect } from 'react';
import { Paper, IconButton, LinearProgress } from '@mui/material';
import { PlayCircleFilled, PauseCircleFilled } from '@mui/icons-material';
import DisplayTemplate from '../displayTemplate';

let globalAudioRef = null; // Shared reference to manage global audio state
let globalSetIsPlaying = null; // Shared function to update the state of the previous audio

export default function AudioRenderer({ content, contentType, style, renderDefault = false, language, contentDisplayType, contentUrl, mediaStyle, overrideHTML, helpText, templateType, ...props }) {

    const Component = () => {
        const [isPlaying, setIsPlaying] = useState(false);
        const [currentTime, setCurrentTime] = useState(0);
        const [duration, setDuration] = useState(0);
        const audioRef = useRef(null);

        const toggleAudio = () => {
            const audio = audioRef.current;
            if (audio.paused) {
                if (globalAudioRef && globalAudioRef !== audio) {
                    globalAudioRef.pause();
                    globalAudioRef.currentTime = 0;
                    if (globalSetIsPlaying) globalSetIsPlaying(false); // Update the state of the previous audio
                }
                globalAudioRef = audio; // Set current audio as globally active
                globalSetIsPlaying = setIsPlaying; // Share the state updater
                audio.play();
                setIsPlaying(true);
            } else {
                audio.pause();
                setIsPlaying(false);
            }
        };

        const updateTime = () => {
            const audio = audioRef.current;
            setCurrentTime(audio.currentTime);
            setDuration(audio.duration);
        };

        // const formatTime = (time) => {
        //     const minutes = Math.floor(time / 60);
        //     const seconds = Math.floor(time % 60);
        //     return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        // };

        const formatTime = (time) => {
            if (isNaN(time)) return '0:00';
            const totalSeconds = Math.floor(time);
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${minutes}:${String(seconds).padStart(2, '0')}`;
        };



        useEffect(() => {
            // Cleanup when component unmounts or playback ends
            return () => {
                if (globalAudioRef === audioRef.current) {
                    globalAudioRef = null;
                    globalSetIsPlaying = null;
                }
            };
        }, []);

        return (
            <Paper elevation={2} style={{ ...styles.container, ...style }}>
                <div>
                    <IconButton onClick={toggleAudio}>
                        {isPlaying ? <PauseCircleFilled style={styles.icons} /> : <PlayCircleFilled style={styles.icons} />}
                    </IconButton>
                    <audio
                        ref={audioRef}
                        src={contentUrl}
                        onTimeUpdate={updateTime}
                        onLoadedMetadata={updateTime}
                        onEnded={() => {
                            setIsPlaying(false)
                            if (globalAudioRef === audioRef.current) {
                                globalAudioRef = null;
                                globalSetIsPlaying = null;
                            }
                        }}
                    />
                </div>
                <div style={styles.progressContainer}>
                    <LinearProgress
                        variant="determinate"
                        value={(currentTime / duration) * 100}
                        style={{ marginTop: '20px' }}
                    />
                    {/* <div style={styles.timeContainer}>
                        <span>{formatTime(currentTime)}</span>
                        <span>{formatTime(duration || 0)}</span>
                    </div> */}
                    <div style={styles.timeContainer}>
                        <span>{formatTime(currentTime)}/{formatTime(duration || 0)}</span>
                    </div>
                </div>
            </Paper>
        )
    };

    return renderDefault ? <Component /> : <DisplayTemplate templateType={templateType} components={[Component]} {...props} />

};

const styles = {
    container: {
        display: 'flex',
        padding: '20px',
        position: 'relative'
    },
    progressContainer: {
        width: '100%',
        marginTop: '4px'
    },
    timeContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px'
    },
    icons: {
        height: '38px',
        width: '38px',
    }
};
